import { useEffect } from 'react';
import type InventoryConditionalTile from '~/contracts/srp/InventoryConditionalTile';
import {
  getNewCarHref,
  getNewCarVariant
} from '~/utilities/srp/new-car/getNewCarVariant';
import GenericBanner from './GenericBanner';
import MakeBanner from './MakeBanner';
import MakeModelBanner from './MakeModelBanner';
import { PromoBanners } from '../constants';
import { useSendViewedBannerEvent } from '../hooks';
import { getBannerName } from '../utils';

type OwnProps = {
  tileMetadata: InventoryConditionalTile['tileMetadata'];
};

const bannerName = getBannerName(PromoBanners.NewCar);

export default function NewCarBanner({ tileMetadata }: OwnProps) {
  const sendViewedBannerEvent = useSendViewedBannerEvent();
  const href = getNewCarHref(tileMetadata);
  const variant = getNewCarVariant(tileMetadata);

  useEffect(() => {
    sendViewedBannerEvent(bannerName);
  }, [sendViewedBannerEvent]);

  switch (variant) {
    case 'Make':
      return (
        <MakeBanner
          bannerName={bannerName}
          href={href}
          make={tileMetadata?.make ?? ''}
        />
      );
    case 'MakeModel':
      return (
        <MakeModelBanner
          bannerName={bannerName}
          href={href}
          make={tileMetadata?.make ?? ''}
          model={tileMetadata?.model ?? ''}
        />
      );
    case 'Generic':
    default:
      return <GenericBanner bannerName={bannerName} href={href} />;
  }
}
